import { StepType } from './onboardingManager'

export function activateOwnerSubStep(
  setSteps: React.Dispatch<React.SetStateAction<StepType[]>>,
  subStepName: string,
): void {
  setSteps((prev) =>
    prev.map((step) => {
      const newStep = { ...step }
      if (step.name === 'owners') {
        newStep.subSteps = step.subSteps?.map((subStep) =>
          subStep.name === subStepName ? { ...subStep, status: 'active' } : { ...subStep, status: '' },
        )
      }
      return newStep
    }),
  )
}
